<template>
  <button
    @click="handleAudioChange()"
    class="h-10 sm:h-12 w-10 sm:w-12 px-3 py-2 sm:px-3 sm:py-3 mr-32 sm:mr-48 my-6 md:my-12 rounded-full bg-black flex flex-row items-center"
  >
    <sound-on-icon v-if="soundOn" class="w-4 h-4 sm:w-6 sm:h-6" />
    <sound-off-icon v-else class="w-4 h-4 sm:w-6 sm:h-6" />
  </button>
</template>

<script>
import SoundOnIcon from "./SoundOnIcon";
import SoundOffIcon from "./SoundOffIcon";

export default {
  name: "TheLanguageSwitcher",
  props: {
    soundOn: {
      type: Boolean,
      required: true,
      default: true,
    },
  },
  components: {
    SoundOnIcon,
    SoundOffIcon,
  },
  methods: {
    handleAudioChange() {
      this.$emit("audioChange");
    },
  },
};
</script>

<style lang="css" scoped>
</style>